import React from 'react';

export default class Main extends React.Component{
    constructor(props){
        super(props);
    }
    render(){
        const { userid,username,usertype,time,template } = this.props;
        String.prototype.replaceAll = function(s1, s2) {
            return this.replace(new RegExp(s1, "gm"), s2);
        }
        let msg = template.replaceAll("\\${user}", `<span class="wf-reject-msg-user"><a href="javaScript:openhrm(${userid})" onClick="javaScript:window.pointerXY(event)">${username}</a></span>`)
        if(usertype == 1){
            msg = template.replaceAll("\\${user}", `<span class="wf-reject-msg-user"><a target="_blank" href="/spa/crm/static/index.html#/main/crm/customerView?customerId=${userid}" >${username}</a></span>`)
        }
        if(usertype == 2){
            msg = template.replaceAll("\\${user}", `<span class="wf-reject-msg-user">${username}</span>`)
        }
        msg = msg.replace("${time}", `<span class="wf-reject-msg-time">${time}</span>`);
        return (
            <div className="wf-reject-msg">
                <span><i className="icon-coms02-Warning-01" /></span>
                <span dangerouslySetInnerHTML={{__html:msg}}></span>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/topPropmpt/RejectInfo.js